import React from 'react';
import Modal from '../../../components/common/Modal';

const EmailLogView = ({ isOpen, onClose, data }) => {
  if (!data) return null;

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return 'N/A';
    try {
      return new Date(timestamp).toLocaleString();
    } catch (error) {
      return timestamp;
    }
  };

  const getStatusBadge = (status) => {
    const statusLower = status?.toLowerCase() || '';
    let badgeClass = 'badge bg-secondary';
    
    if (statusLower.includes('success') || statusLower.includes('sent')) {
      badgeClass = 'badge bg-success';
    } else if (statusLower.includes('failed') || statusLower.includes('error')) {
      badgeClass = 'badge bg-danger';
    } else if (statusLower.includes('pending') || statusLower.includes('queued')) {
      badgeClass = 'badge bg-warning';
    }
    
    return <span className={badgeClass}>{status || 'Unknown'}</span>;
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Email Log Details"
      size="lg"
    >
      <div className="modal-body">
        <div className="row mb-3">
          <div className="col-4 fw-bold">Subject</div>
          <div className="col-8">{data.subject || 'N/A'}</div>
        </div>
        <div className="row mb-3">
          <div className="col-4 fw-bold">Recipient</div>
          <div className="col-8">{data.recipient || 'N/A'}</div>
        </div>
        <div className="row mb-3">
          <div className="col-4 fw-bold">Status</div>
          <div className="col-8">{getStatusBadge(data.status)}</div>
        </div>
        <div className="row mb-3">
          <div className="col-4 fw-bold">Time Stamp</div>
          <div className="col-8">{formatTimestamp(data.timestamp)}</div>
        </div>
        
        {data.errorMessage && (
          <div className="row mb-3">
            <div className="col-4 fw-bold">Error Message</div>
            <div className="col-8">
              <div className="alert alert-danger mb-0">
                {data.errorMessage}
              </div>
            </div>
          </div>
        )}

        {data.id && (
          <div className="row mb-3">
            <div className="col-4 fw-bold">Log ID</div>
            <div className="col-8">{data.id}</div>
          </div>
        )}

        {data.sender && (
          <div className="row mb-3">
            <div className="col-4 fw-bold">Sender</div>
            <div className="col-8">{data.sender}</div>
          </div>
        )}

        {data.attempts && (
          <div className="row mb-3">
            <div className="col-4 fw-bold">Attempts</div>
            <div className="col-8">{data.attempts}</div>
          </div>
        )}

        {data.createdAt && data.createdAt !== data.timestamp && (
          <div className="row mb-3">
            <div className="col-4 fw-bold">Created At</div>
            <div className="col-8">{formatTimestamp(data.createdAt)}</div>
          </div>
        )}
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Close
        </button>
      </div>
    </Modal>
  );
};

export default EmailLogView; 